//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data () {
		return {
			csTestUrl: 'https://iqos-reklamace-be.pmitest.cz',
			skTestUrl: 'https://iqos-reklamacie-sk-be.pmitest.cz',
			csDemoUrl: 'https://claim-demo-cz-be.pmitest.cz',
			skDemoUrl: 'https://claim-demo-sk-be.pmitest.cz',
		};
	},
};
